import React, { useState, useRef } from "react";

const ScrambleText = ({ text, speed = 30 }) => {
  const [display, setDisplay] = useState(text);
  const intervalRef = useRef(null);
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  const handleMouseEnter = () => {
    let frame = 0;
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setDisplay((prev) => {
        return text
          .split("")
          .map((char, i) => {
            if (i < frame) return text[i];
            return characters[Math.floor(Math.random() * characters.length)];
          })
          .join("");
      });

      frame++;

      if (frame > text.length) {
        clearInterval(intervalRef.current);
      }
    }, speed);
  };

  const handleMouseLeave = () => {
    clearInterval(intervalRef.current);
    setDisplay(text);
  };

  return (
    <span
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="scramble-text"
      style={{ cursor: "pointer" }}
    >
      {display}
    </span>
  );
};

export default ScrambleText;
